(() => {
  if (customElements.get('discount-announcement-bar')) return;

  const DISMISSED_BANNERS_STORAGE_KEY = 'canpressco:dismissed-header-banners';
  const DISCOUNT_CODE_COOKIE_NAME = 'discount_code';

  class DiscountAnnouncementBar extends HTMLElement {
    constructor() {
      super();

      this.messageElement = this.querySelector('[data-discount-announcement-message]');
      this.unsubscribe = null;
    }

    connectedCallback() {
      this.initializeDismissibleBanners();
      this.updateFromCart();

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.updateFromCart());
      }
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    async updateFromCart() {
      if (!this.messageElement) return;

      if (this.isBannerDismissed(this)) {
        this.setAttribute('hidden', '');
        return;
      }

      try {
        const response = await fetch(this.getCartUrl(), {
          headers: {
            Accept: 'application/json',
          },
        });

        if (!response.ok) return;

        const cart = await response.json();
        const discountTitle = this.getDiscountTitle(cart);

        if (discountTitle) {
          this.messageElement.textContent = `Your code ${discountTitle} is active, applied at checkout.`;
          this.removeAttribute('hidden');
        } else {
          this.messageElement.textContent = '';
          this.setAttribute('hidden', '');
        }
      } catch (error) {
        console.error(error);
      }
    }

    initializeDismissibleBanners() {
      document.querySelectorAll('[data-dismissible-banner]').forEach((banner) => {
        if (this.isBannerDismissed(banner)) {
          banner.setAttribute('hidden', '');
        }

        if (banner.dataset.dismissibleBannerInitialized === 'true') return;

        banner
          .querySelectorAll('[data-dismissible-banner-close]')
          .forEach((button) => button.addEventListener('click', this.closeBanner.bind(this)));

        banner.dataset.dismissibleBannerInitialized = 'true';
      });
    }

    closeBanner(event) {
      const banner = event.currentTarget.closest('[data-dismissible-banner]');

      if (!banner) return;

      banner.setAttribute('hidden', '');
      this.storeDismissedBannerId(banner.dataset.dismissibleBannerId);
    }

    getCartUrl() {
      const root = window.Shopify?.routes?.root || '/';
      return `${root}cart.js`;
    }

    getDiscountTitle(cart) {
      const cartDiscountTitle = cart.cart_level_discount_applications?.[0]?.title;

      if (cartDiscountTitle) return cartDiscountTitle;

      const discountedItem = cart.items?.find((item) => item.discounts?.[0]?.title);

      if (discountedItem?.discounts?.[0]?.title) {
        return discountedItem.discounts[0].title;
      }

      return this.getDiscountCodeCookie();
    }

    getDiscountCodeCookie() {
      const discountCookie = document.cookie
        .split(';')
        .find((cookie) => cookie.trim().startsWith(`${DISCOUNT_CODE_COOKIE_NAME}=`));

      if (!discountCookie) return '';

      const cookieValue = discountCookie.split('=').slice(1).join('=');

      try {
        return decodeURIComponent(cookieValue.replace(/\+/g, ' ')).trim();
      } catch (error) {
        return cookieValue.trim();
      }
    }

    isBannerDismissed(banner) {
      return this.getDismissedBannerIds().includes(banner.dataset.dismissibleBannerId);
    }

    getDismissedBannerIds() {
      try {
        const dismissedBannerIds = JSON.parse(sessionStorage.getItem(DISMISSED_BANNERS_STORAGE_KEY) || '[]');

        return Array.isArray(dismissedBannerIds) ? dismissedBannerIds : [];
      } catch (error) {
        return [];
      }
    }

    storeDismissedBannerId(bannerId) {
      if (!bannerId) return;

      const dismissedBannerIds = this.getDismissedBannerIds();

      if (dismissedBannerIds.includes(bannerId)) return;

      try {
        sessionStorage.setItem(
          DISMISSED_BANNERS_STORAGE_KEY,
          JSON.stringify([...dismissedBannerIds, bannerId])
        );
      } catch (error) {
        return;
      }
    }
  }

  customElements.define('discount-announcement-bar', DiscountAnnouncementBar);
})();
